import { useContext } from "react";
import { ManifestContext } from "./ManifestContextComponent";

export const useManifestContextHook = () => {
    // get the context
    const context = useContext(ManifestContext);
    // if `undefined`, throw an error
    if (!context) {
        throw new Error("useManifestContext was used outside of its Provider");
    }
    return context;
};